import React, { useEffect, useState } from "react";
import "./hero.css";
import { Icon } from "@/components/ui-components/icon";
import type { InterpolationValues } from "@/i18n/types";
import { assetUrl } from "@/utils/assets";

const HERO_BACKGROUND_IMAGES = [
    assetUrl("images/hero/fresh_vegetable_aisle_shopper.jpg"),
    assetUrl("images/hero/grocery_aisle_shopper.jpg"),
    assetUrl("images/hero/store_front_customer_arrival.jpg"),
    assetUrl("images/hero/produce_section_shopping.jpg"),
    assetUrl("images/hero/stocked_store_interior.jpg"),
    assetUrl("images/hero/fresh_chilies_spices_display.jpg"),
];

const HERO_SLIDE_INTERVAL_MS = 5000;

export function Hero({ t }: { t: (key: string, values?: InterpolationValues) => string }) {
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        if (HERO_BACKGROUND_IMAGES.length < 2) return;
        const cycleDuration = Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue("--ui-hero-cycle-duration") || `${HERO_SLIDE_INTERVAL_MS}`, 10) || HERO_SLIDE_INTERVAL_MS;
        const timer = setInterval(() => {
            setActiveSlide((current) => (current + 1) % HERO_BACKGROUND_IMAGES.length);
        }, cycleDuration);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className="hero">
            <div className="hero-background" aria-hidden="true">
                {HERO_BACKGROUND_IMAGES.map((src, index) => (
                    <div
                        key={src}
                        className={`hero-background-slide${index === activeSlide ? " is-active" : ""}`}
                        style={{
                            backgroundImage: `url(${src})`,
                            transitionDuration: "var(--ui-hero-transition-duration, 1800ms)",
                            transitionProperty: "opacity, transform, filter",
                            transitionTimingFunction: "var(--ui-motion-easing, cubic-bezier(.2,.8,.2,1))"
                        }}
                    />
                ))}
            </div>
            <div className="hero-copy">
                <span className="hero-kicker">{t("home.hero.kicker")}</span>
                <h1>{t("home.hero.titleBefore")} <em>{t("home.hero.titleAccent")}</em></h1>
                <p>{t("home.hero.description")}</p>
                <div className="hero-actions">
                    <a className="hero-primary" href="#products"><Icon name="bag" size="sm" />{t("home.hero.startShopping")}</a>
                    <a className="hero-secondary" href="#categories">{t("home.hero.browseCategories")}</a>
                </div>
            </div>
        </section>
    );
}
